import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonContent, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: 'app-notification-info-modal',
  templateUrl: './notification-info-modal.component.html',
  styleUrls: ['./notification-info-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon
  ]
})
export class NotificationInfoModalComponent {
  @Input() title: string = 'NOTIFICATIONS';
  @Input() message: string = '';

  constructor(private modalController: ModalController) {
    addIcons({ close });
  }

  dismiss() {
    this.modalController.dismiss();
  }
}